import { z } from 'zod';

import type { IconName } from '@/components/Icon/iconMap';

import {
  type TestSetStatus,
  TestSetStatus as TDS,
  type TestSetStatusFilter,
} from './-query/type';

const testSetStatusValues = Object.values(TDS) as [
  TestSetStatus,
  ...TestSetStatus[],
];

export const TestSetStatusFilterSchema = z.enum([
  'ALL',
  ...testSetStatusValues,
]);

/**
 * テストセットタブの上部に表示するステータスタブの並び順。
 *
 * ユーザ要望順:
 *   新規テスト設計中 / テストケース実装中 / 実施待ち / 実施済み /
 *   結果承認済み / すべて / 実施なし
 */
export const STATUS_TABS = [
  TDS.DESIGNING,
  TDS.IMPLEMENTING,
  TDS.READY,
  TDS.EXECUTED,
  TDS.APPROVED,
  'ALL',
  TDS.NOT_EXECUTED,
] as const satisfies readonly TestSetStatusFilter[];

export function buildTestSetTabChangeSearch(tab: string) {
  const result = TestSetStatusFilterSchema.safeParse(tab);
  return {
    status: result.success ? result.data : ('ALL' as const),
    pageIndex: 0,
    sortColumn: undefined,
    orderDirection: 'desc' as const,
  };
}

export const TAB_TO_ICON: Record<TestSetStatusFilter, IconName | null> = {
  ALL: null,
  [TDS.DESIGNING]: 'ConstructionIcon',
  [TDS.IMPLEMENTING]: 'Code2Icon',
  [TDS.READY]: 'Clock2Icon',
  [TDS.EXECUTED]: 'ListCheckIcon',
  [TDS.APPROVED]: 'BadgeCheckIcon',
  [TDS.NOT_EXECUTED]: 'Trash2Icon',
};
